import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { datadogRum } from '@datadog/browser-rum';
import { useContext, useEffect } from 'react';
import useGetCkPromoFromDiscountContext from './useGetCkPromoFromDiscountContext';

export default function useTrackCreditKarmaPromo() {
  const { trackEvent } = useContext(AnalyticsContext);
  const { shouldShowCkPromo } = useGetCkPromoFromDiscountContext();

  useEffect(() => {
    if (shouldShowCkPromo) {
      trackEvent('credit-karma-promo-displayed');
      datadogRum.addAction('credit-karma-promo-displayed');
    }
  }, [shouldShowCkPromo, trackEvent]);
}
